import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Page from '../../components/Page'
import style from './style'
// material
import { styled } from '@material-ui/core/styles'
import { Box, Grid, Typography, withStyles } from '@material-ui/core'
import translator from 'src/translate'
import LocalOfferIcon from '@material-ui/icons/LocalOffer'
// components
import SuccessCode from './success'
import Subscription from './subscription'
//
import { componentBoxShowAction } from '../../reducers/component-box/action'
import ComponentBoxContent from '../../model/component-box'
import { codeVerifierAction } from '../../reducers/common/action'
import UserType from '../../model/user-types'
import { CoreButton, CoreTextField } from 'src/components/core'
import { userLimitsGetAction } from 'src/reducers/user-limits/action'
import { selectUserLimits } from 'src/reducers/user-limits/selector'

const RootStyle = styled(Page)(({ theme }) => ({
  minHeight: '100%',
  paddingTop: theme.spacing(5),
  paddingBottom: theme.spacing(10),
}))

// ----------------------------------------------------------------------

function UseCoupon(props) {
  const dispatch = useDispatch()
  const { classes, history } = props
  const userLimits = useSelector(selectUserLimits)

  const [code, setCode] = useState('')
  const [userType, setType] = useState('')

  useEffect(() => {
    if (!userLimits) {
      dispatch(userLimitsGetAction())
    }
  }, [dispatch, userLimits])

  useEffect(() => {
    if (userLimits && userLimits[0]) {
      setType(userLimits[0].limit.roleType)
    }
  }, [userLimits])

  const onHandleAppsumoCode = event => {
    if (code != '') {
      dispatch(
        codeVerifierAction(code, () => {
          successCode()
        }),
      )
    }
  }
  const onHandleSubscription = event => {
    if (code != '') {
      subscription()
    }
  }
  const successCode = () => {
    dispatch(
      componentBoxShowAction(
        new ComponentBoxContent(
          <SuccessCode history={history} dispatch={dispatch} />,
          { hideCloseButton: true },
        ),
      ),
    )
  }
  const subscription = () => {
    dispatch(
      componentBoxShowAction(
        new ComponentBoxContent(
          <Subscription history={history} dispatch={dispatch} />,
          { hideCloseButton: false, header: 'Warning!' },
        ),
      ),
    )
  }
  return (
    <RootStyle title="Use Coupon">
      <Box m={5}></Box>
      <Grid className={classes.innerGrid}>
        <LocalOfferIcon color="primary"> </LocalOfferIcon>
        <Box m={1}></Box>
        <Typography variant="h3" paragraph>
          {translator._('pricing.useCoupon')}
        </Typography>
      </Grid>
      <Box m={2}></Box>

      <Grid container className={classes.innerGrid}>
        <Grid item xs={6} md={2}>
          <CoreTextField
            fullWidth
            label={'Code'}
            id="code"
            name="code"
            onChange={event => {
              setCode(event.target.value)
            }}
          />
        </Grid>
        <Box m={2}></Box>

        <CoreButton
          variant="contained"
          color="primary"
          size="medium"
          onClick={() => {
            // AppSumo tiers stack codes, and Basic and Standard (trial) have no
            // paid subscription, so they redeem directly. Anyone else has to
            // cancel their subscription first.
            if (
              UserType.isAppSumoUser(userType) ||
              UserType[userType] === UserType[1] ||
              UserType[userType] === UserType[29]
            ) {
              onHandleAppsumoCode()
            } else {
              onHandleSubscription()
            }
          }}
        >
          {translator._('pricing.redeem')}
        </CoreButton>
      </Grid>
      <Box m={5}></Box>
      <Grid item align="center">
        <Typography>
          {translator._('pricing.contact')}:{' '}
          <a href="mailto:support@minicoursegenerator.com">
            support@minicoursegenerator.com
          </a>
        </Typography>
      </Grid>
    </RootStyle>
  )
}

export default withStyles(style)(UseCoupon)
